import { createContext, useContext } from "react";

const formContext = createContext('')

export const FormProvider = formContext.Provider
export const useFormContext = () => useContext(formContext)

export default formContext